import Cookies from "universal-cookie"
import * as cookieNames from "../booking/constants/Cookies"

const cookies = new Cookies()

export const getCookie = (name) => {
  return cookies.get(name)
}

export const setCookie = (name, value, options = { path: "/" }) => {
  cookies.set(name, value, options)
}

export const setCookieWithExpiration = (name, value, date) => {
  cookies.set(name, value, { expires: new Date(date), path: "/" })
}

export const removeCookie = (name) => {
  cookies.remove(name)
}

export const setLogoutReturnCookie = (url) => {
  setCookie(cookieNames.POST_LOGOUT_RETURN_URL, encodeURI(url), { path: "/" })
}

export const deleteCookie = (name) => {
  cookies.set(name, undefined, { expires: new Date(1700, 1, 1), path: "/" })
}

export const getUserId = () => {
  return getCookie(cookieNames.IDP_USER_ID) ?? getCookie(cookieNames.CPH_TEMP_USER)
}

export const getAccessToken = () => {
  return getCookie(cookieNames.ACCESS_TOKEN)
}

export const removeAccessToken = () => {
  return removeCookie(cookieNames.ACCESS_TOKEN)
}

export const isLoggedIn = () => {
  return !!getAccessToken()
}
